/* SAML NameId format constants*/
export const UNSPECIFIED = "UNSPECIFIED";
export const PERSISTENT = "PERSISTENT";
export const TRANSIENT = "TRANSIENT";
export const EMAIL_ADDRESS = "EMAIL_ADDRESS";
export const WINDOWS_DOMAIN_QUALIFIED_NAME = "WINDOWS_DOMAIN_QUALIFIED_NAME"

/* User Attributes constants*/
export const USER_ID = "USER_ID";
export const FIRST_NAME = "FIRST_NAME";
export const LAST_NAME = "LAST_NAME";
export const EMAIL = "EMAIL";
export const DOMAIN = "DOMAIN";
export const USER_PRINCIPAL_NAME = "USER_PRINCIPAL_NAME";
export const USER_DISPLAY_NAME = "USER_DISPLAY_NAME";
export const CUSTOM_ATTRIBUTE = "CUSTOM_ATTRIBUTE";

/* SAML metadata constants*/
export const PUBLIC_KEY_CERTIFICATE_INFO = "publicKeyCertificateInfo";
export const SLO_ITEMS = "SloItems";
export const ACS_ITEMS = "AcsItems";
export const NAME_ID_FORMAT = "samlNameIdFormatEnum";

/* Selected metadata import mode*/
export const IMPORT_FROM_FILE = "IMPORT_FROM_FILE";
export const IMPORT_FROM_URL = "IMPORT_FROM_URL";

/* default User Attributes constant*/
export const DEFAULT_USER_ATTRIBUTES = [
  {
    "idpUserAttributeEnum": FIRST_NAME,
    "userAttributeName": "firstName",
    "userSpecifiedValue": ""
  },
  {
    "idpUserAttributeEnum": LAST_NAME,
    "userAttributeName": "lastName",
    "userSpecifiedValue": ""
  },
  {
    "idpUserAttributeEnum": EMAIL,
    "userAttributeName": "email",
    "userSpecifiedValue": ""
  }
];



// WEBPACK FOOTER //
// ./src/constants/samlConstants.js